import openModeEnum from "../../enums/openModeEnum";
import { parseJsonValue } from "../utils";

const buttonSideEnum = {
    Left: "left",
    Right: "right",
};

const defaultPrimaryButton = {
    enabled: true,
    side: buttonSideEnum.Left,
    text: "",
    textColor: "#8622A3",
    backgroundColor: "#FFFFFF",
    borderColor: "#8622A3",
    link: "",
    openMode: openModeEnum.NewTab,
};

const defaultSecondaryButton = {
    ...defaultPrimaryButton,
    enabled: false,
    side: buttonSideEnum.Right,
    backgroundColor: "#8622A3",
    textColor: "#FFFFFF",
};

const normalizeButton = (button, defaults) => {
    if (!button)
        return null;

    return {
        ...defaults,
        ...button,
        text: button.text ?? "",
    };
};

const parsePromotionMetadata = (additionalInfo) => {
    const promotion = parseJsonValue(additionalInfo, {});

    let primaryButton = normalizeButton(
        promotion.primaryButton, {
        ...defaultPrimaryButton,
        enabled: Boolean(promotion.primaryButton),
    }) ?? { ...defaultPrimaryButton, enabled: false };

    let secondaryButton = normalizeButton(
        promotion.secondaryButton, {
        ...defaultSecondaryButton,
        enabled: Boolean(promotion.secondaryButton),
    }) ?? defaultSecondaryButton;

    if (primaryButton.side === secondaryButton.side)
        secondaryButton.side = secondaryButton.side === buttonSideEnum.Left ? buttonSideEnum.Right : buttonSideEnum.Left;

    return {
        contentType: promotion.contentType,
        title: promotion.title ?? "",
        primaryButton,
        secondaryButton,
    };
};

export default parsePromotionMetadata;
